import React, { PureComponent } from 'react';
import request from './utils/request';
import axios from 'axios';
import qs from 'qs';

import './App.scss';

import Header from './components/Header';
import Footer from './components/Footer';
import Swiper from './components/Swiper';
import Template1 from './components/Template1';
import Template2 from './components/Template2';
import Template3 from './components/Template3';
import Template4 from './components/Template4';
import Template5 from './components/Template5';

const getTopicInfo = topicUrl =>
  request.get(`getTopicInfoListByTopicUrl?topicUrl=${topicUrl}`);

class App extends PureComponent {
  state = {
    topicInfo: {
      topicUrl: '',
      topicTittle: '',
      memo: '',
      id: null,
      coverPic: '',
      classInfo: []
    }
  };

  async componentWillMount() {
    // let href =
    // 'http://artest.lanxiongtiyu.com/preview/?topicName=weeexxxx2323/';
    let href = window.location.href;

    if (href.includes('/preview/?topicName=')) {
      href = `service.lanxiongsports.com/special/${
        href.split('/preview/?topicName=')[1]
      }`;
    } else if (
      href.includes('artest.lanxiongtiyu.com') &&
      !href.includes('/preview/?topicName')
    ) {
      let path = href.split('artest.lanxiongtiyu.com/')[1];
      if (path.includes('/')) {
        path = path.split('/')[0];
      }
      href = `service.lanxiongsports.com/special/${path}`;
    } else if (href.includes('from=')) {
      href = href.split('?')[0].split('//')[1];
    } else {
      href = href.split('//')[1];
    }

    const infoRes = await getTopicInfo(href);
    if (infoRes.code === 200) {
      this.setState({
        topicInfo: infoRes.data
      });
    }

    //微信分享
    const url = window.location.href.split('#')[0];
    const params = {
      url
    };

    const res = await axios.post(
      'https://ar.lanxiongtiyu.com/ar_api/v1/wx/getTicketSign.do',
      qs.stringify(params)
    );

    window.wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: 'wx4690a55401737a1f', // 必填，公众号的唯一标识
      timestamp: res.data.timestamp, // 必填，生成签名z 的时间戳
      nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名
      jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'] // 必填，需要使用的JS接口列表
    });

    window.wx.ready(() => {
      // const _url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appId}&redirect_uri=https://ar.lanxiongtiyu.com/ar_api/v1/wx/opLogin.do?redirectUrl=${window.location.origin}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      // const link = `${window.location.origin}/redirect?redirectUrl=${_url}`
      const timeLineConf = {
        title: this.state.topicInfo.topicTittle, // 分享标题
        imgUrl: this.state.topicInfo.coverPic, // 分享图标
        success() {}
      };

      const friendsConf = {
        title: this.state.topicInfo.topicTittle, // 分享标题
        // desc: this.activityDetail.lecturerInfo.intro, // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.state.topicInfo.coverPic, // 分享图标
        desc: this.state.topicInfo.memo,
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success() {}
      };

      console.log(friendsConf, timeLineConf);
      window.wx.onMenuShareTimeline(timeLineConf);
      window.wx.onMenuShareAppMessage(friendsConf);
    });
  }

  render() {
    const {
      classInfo,
      topicTittle,
      topicLogo,
      headBackgroud
    } = this.state.topicInfo;
    const headBackground = headBackgroud;
    document.title = topicTittle;

    return (
      <>
        <Header
          topicTittle={topicTittle}
          topicLogo={topicLogo}
          headBackground={headBackground}
        />
        {classInfo.map(item => {
          switch (item.classModel) {
            case 'swiper':
              return (
                <Swiper
                  articleInfo={item.articleInfo}
                  headBackground={headBackground}
                  key={item.classTittle}
                />
              );
            case 'template1':
              return <Template1 templateInfo={item} key={item.classTittle} />;
            case 'template2':
              return <Template2 templateInfo={item} key={item.classTittle} />;
            case 'template3':
              return <Template3 templateInfo={item} key={item.classTittle} />;
            case 'template4':
              return <Template4 templateInfo={item} key={item.classTittle} />;
            case 'template5':
              return <Template5 templateInfo={item} key={item.classTittle} />;
            default:
              return '';
          }
        })}
        {classInfo.length > 0 && <Footer />}
      </>
    );
  }
}

export default App;
